const defaultValue = 'default value from config.ts, change me pls';
let config = {
  TF_AGW_URL: import.meta.env.VITE_TF_AGW_URL ? import.meta.env.VITE_TF_AGW_URL : defaultValue,
  TF_ERP_URL: import.meta.env.VITE_TF_ERP_URL ? import.meta.env.VITE_TF_ERP_URL : defaultValue,
  TF_HUB_URL: import.meta.env.VITE_TF_HUB_URL ? import.meta.env.VITE_TF_HUB_URL : defaultValue,
  TIO_HUB_URL: import.meta.env.VITE_TIO_HUB_URL ? import.meta.env.VITE_TIO_HUB_URL : defaultValue,
  RTSG_HUB_URL: import.meta.env.VITE_RTSG_HUB_URL ? import.meta.env.VITE_RTSG_HUB_URL : defaultValue,
  DBG_HUB_URL: import.meta.env.VITE_DBG_HUB_URL ? import.meta.env.VITE_DBG_HUB_URL : defaultValue,
  TF_ADM_URL: import.meta.env.VITE_TF_ADM_URL ? import.meta.env.VITE_TF_ADM_URL : defaultValue,
  FIREBASE_EMULATOR: import.meta.env.VITE_FIREBASE_EMULATOR ? import.meta.env.VITE_FIREBASE_EMULATOR : defaultValue,
  FIREBASE_USE_AUTH_EMULATOR: import.meta.env.VITE_FIREBASE_USE_AUTH_EMULATOR
    ? import.meta.env.VITE_FIREBASE_USE_AUTH_EMULATOR
    : defaultValue,
  INSTANCE_TYPE: import.meta.env.VITE_INSTANCE_TYPE ? import.meta.env.VITE_INSTANCE_TYPE : defaultValue,
};

export interface Config {
  TF_AGW_URL: string;
  TF_ERP_URL: string;
  TF_HUB_URL: string;
  TIO_HUB_URL: string;
  RTSG_HUB_URL: string;
  DBG_HUB_URL: string;
  TF_ADM_URL: string;
  FIREBASE_EMULATOR: string;
  FIREBASE_USE_AUTH_EMULATOR: string;
  INSTANCE_TYPE: 'local' | 'staging' | 'production';
}
export const setConfig = (configData: Config): void => {
  config = configData;
};

export const getConfig = (): Config => config;
